import type { ChatMessageType } from '../types/chat-message';

/**
 * 메시지 관련 순수 함수들
 */

/**
 * 사용자 메시지를 채팅 목록에 추가
 */
export const addUserMessage = (
  messages: ChatMessageType[],
  message: string
): ChatMessageType[] => {
  if (!message.trim()) return messages;

  const userMessage: ChatMessageType = { sender: 'user', message };
  return [...messages, userMessage];
};

/**
 * 새로운 스트리밍 에이전트 메시지를 시작 (첫 번째 청크)
 */
export const addStreamingAgentMessage = (
  messages: ChatMessageType[],
  content: string,
  turnId: string
): ChatMessageType[] => {
  if (!content.trim()) return messages;

  const streamingMessage: ChatMessageType = {
    sender: 'agent',
    message: content,
    isStreaming: true,
    turnId
  };

  return [...messages, streamingMessage];
};

/**
 * 스트리밍 중인 에이전트 메시지 업데이트 (중간 청크들)
 */
export const updateStreamingAgentMessage = (
  messages: ChatMessageType[],
  content: string,
  turnId: string
): ChatMessageType[] => {
  const messageIndex = messages.findIndex(
    msg => msg.sender === 'agent' && msg.isStreaming && msg.turnId === turnId
  );

  if (messageIndex === -1) {
    // 스트리밍 메시지가 없으면 새로 추가
    return addStreamingAgentMessage(messages, content, turnId);
  }

  // 기존 스트리밍 메시지 업데이트
  const updatedMessages = [...messages];
  updatedMessages[messageIndex] = {
    ...updatedMessages[messageIndex],
    message: content
  };

  return updatedMessages;
};

/**
 * 스트리밍 메시지를 최종 메시지로 완성
 */
export const finalizeStreamingMessage = (
  messages: ChatMessageType[],
  content: string,
  turnId: string
): ChatMessageType[] => {
  const messageIndex = messages.findIndex(
    msg => msg.sender === 'agent' && msg.isStreaming && msg.turnId === turnId
  );

  if (messageIndex === -1) {
    // 스트리밍 메시지가 없으면 일반 메시지로 추가
    return addAgentMessage(messages, content);
  }

  // 스트리밍 플래그 제거하여 최종화
  const updatedMessages = [...messages];
  updatedMessages[messageIndex] = {
    ...updatedMessages[messageIndex],
    message: content,
    isStreaming: false
  };

  return updatedMessages;
};

/**
 * 최종 에이전트 메시지를 채팅 목록에 추가 (레거시 호환성)
 */
export const addAgentMessage = (
  messages: ChatMessageType[],
  content: string
): ChatMessageType[] => {
  if (!content.trim()) return messages;

  return [
    ...messages,
    { sender: 'agent', message: content }
  ];
};

/**
 * 메시지 목록 초기화
 */
export const clearMessages = (): ChatMessageType[] => {
  return [];
};

/**
 * 메시지 유효성 검증
 */
export const isValidMessage = (message: string): boolean => {
  return message.trim().length > 0;
};
